import { Component, OnInit, AfterViewChecked,  } from '@angular/core';
declare var $:any;
@Component({
    selector: 'app-to-top',
    templateUrl: './to-top.component.html',
    styleUrls: ['./to-top.component.styl']
})
export class ToTopComponent{
    toTop(){
        $('html, body').stop().animate({scrollTop: 0}, 500);
        // document.body.scrollTop = 0;
        // document.documentElement.scrollTop = 0;
    }
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/share/to-top/to-top.component.ts